import api from '@/api';

const resource = 'merenda/titulo-cardapio';

export default {
  criarCardapio( data ) {
    return api.post( `${resource}`, data );
  },

  editarCardapio( data ) {
    return api.put( `${resource}/${data.identificadortitulocardapio}`, data);
  },

  deletarCardapio( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarCardapios() {
    return api.get( `${resource}` );
  }
};
